import { useEffect, useLayoutEffect } from 'react';
import { applyDocumentShell, applyHead, buildHead } from './head';
import type { RouteMeta } from './seo';

/* useLayoutEffect warns when React renders on the server, which is exactly what
   the prerender pass does. The prerendered HTML already carries the right head
   and shell, so on the server this genuinely has nothing to do. */
const useIsomorphicLayoutEffect =
  typeof window === 'undefined' ? useEffect : useLayoutEffect;

/**
 * Point a route at its entry in the seo.ts table.
 *
 * Layout rather than passive effect: crossing from the site shell to the arcade
 * shell swaps the <body> background from white to ink, and running that after
 * paint shows a white flash on a black screen.
 */
export function useDocument(meta: RouteMeta): void {
  useIsomorphicLayoutEffect(() => {
    applyDocumentShell(meta);
    applyHead(buildHead(meta));
  }, [meta]);
}
